import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { DownloadLogsProgress } from "./DownloadLogsProgress";

export class DownloadLogsProgressResData extends ApiGenericResponse {
    downloadLogsProgress: DownloadLogsProgress;

    constructor(response: AxiosResponse) {
        super(response);
        this.downloadLogsProgress = null;
        if (response.data && response.data.Payload) {
            this.downloadLogsProgress = new DownloadLogsProgress();
            this.downloadLogsProgress.parse(response.data.Payload);
        }
    }
}
